import {Injectable, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class JsonLDService {
  static scriptType = 'application/ld+json';
  constructor(@Inject(DOCUMENT) private _document: Document) {
  }

  removeStructuredData(): void {
    const els:any = [];
    ['structured-data', 'structured-data-org'].forEach(c => {
      els.push(...Array.from(this._document.head.getElementsByClassName(c)));
    });
    els.forEach((el:any) => this._document.head.removeChild(el));
  }

  insertKlixiScript(MetaData?: Record<string, any>): void {
    console.warn("insertKlixiScript");
  }

  insertSchema(schema?: Record<string, any>, className = 'structured-data'): void {
    let script: any;
    let shouldAppend = false;
    let flag = false;
    let controlarray: any;
    if (schema) {
      controlarray = Array.isArray(schema);
      if (controlarray) {
        flag = true;
      }
    } else {
      flag = true;
    }
    if (!flag) {
      if (this._document.head.getElementsByClassName(className).length) {
        script = this._document.head.getElementsByClassName(className)[0];
      } else {
        script = this._document.createElement('script');
        shouldAppend = true;
      }
      script.setAttribute('class', className);
      script.type = JsonLDService.scriptType;
      script.text = JSON.stringify(schema);
      if (shouldAppend) {
        this._document.head.appendChild(script);
      }
    } else {
      this.removeStructuredData();
    }
  }
}
